import './styles.scss';
import { faChevronUp } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';

interface IPricingGroupProps {
  children: React.ReactNode;
  label: string;
  isClosable?: boolean | false;
  className?: string;
  defaultOpen?: boolean;
}

const PricingGroup = (props: IPricingGroupProps) => {
  const { label, isClosable, children, className, defaultOpen = false } = props;

  const [isClosed, setIsClosed] = useState(!defaultOpen);

  const handleClose = () => {
    setIsClosed((prev) => !prev);
  };

  return (
    <div className={`pricing-group-container ${className}`}>
      <div className={`header ${isClosable ? 'is-closable' : ''}`} onClick={handleClose}>
        <div className="header-content">
          {isClosable && (
            <FontAwesomeIcon
              icon={faChevronUp}
              className={`closable-icon ${isClosed && 'is-closed'}`}
            />
          )}
          <span>{label}</span>
        </div>
      </div>
      <div className={`content ${isClosed && 'is-closed-content'}`}>{children}</div>
    </div>
  );
};

export default PricingGroup;
